export default {
  message: {
    'points-importer': {
      new: 'New import',
      title: 'Point importer',
      label: 'File with points',
      undo: 'Reset ({points} points)',
      undo_less: 'Reset',
      repair_invalid_entries: 'Repair invalid entries ({points} points)',
      recalculate: 'Recalculate ({points} points)',
      abort: 'Abort',
      upload: 'Upload ({points} points)',
      downloadSelected: 'Download selected entries',
      addRow: 'Add row',
      'select-year': 'Select import year',
      'select-importer': 'Select importer',
      'importer-type': 'Import type',
      'import-name': 'Import name',
      'switch-point-type': 'File upload / Manual input',
      progress: {
        upload: 'Upload',
        repairing: 'Repairing invalid entries',
        calculating: 'Calculating',
        validating: 'Validating',
        loading: 'Loading import data',
      },
      configurableFields: {
        title: 'Custom fields',
        description: 'Configure which column contains each piece of information. Example: Customer number = B',
        options: {
          emptyOption: 'Select mode (default: Direct)',
          mode: {
            merge: 'Merge',
            addition: 'Addition',
            direct: 'Direct',
          }
        },
        headlines: {
          mode: 'Mode',
          sheet: 'Worksheet',
          columns: 'Columns',
        },
        fields: {
          mode: 'Mode',
          importAll: 'Import all',
          worksheetIndex: 'Worksheet number',
          skipRows: 'Skip rows',
          headerRow: 'Header row',
          firstData: 'First row with data',
          Quantity: 'Quantity',
          Rim: 'Rim',
          Brand: 'Brand',
          IPC: 'IPC',
          Date: 'Date',
          CustomerNumber: 'Customer number',
        }
      },
      historyStatus: {
        failed: 'Calculation aborted',
        pending: 'Not calculated yet',
        completed: 'Calculated',
        calculated: 'Calculated (Validation pending)',
        invalid_points: 'Invalid calculation',
      },
      table: {
        index: '',
        customerNumber: 'Customer number',
        pointsInList: 'Already existing points',
        user: 'Dealer ID',
        points: 'Points from file',
        adds: 'New points',
        added: 'Added points',
        actions: 'Actions',
      },
      item: {
        customer_number: 'Customer number',
        brand: 'Brand',
        rim: 'Rim',
        quantity: 'Quantity',
        dealer_id: 'Dealer ID',
        points_pending: 'New points',
        points_completed: 'Calculated points',
        points_invalid_points: 'Designated points',
        status: 'Status',
        imported_points: 'Imported points',
        actions: 'Actions',
      },
      itemStatus: {
        pending: 'Pending',
        merged: 'Already imported',
        calculating: 'Calculation pending',
        calculated: 'Calculated',
      },
      alert: {
        success: 'Points successfully imported',
      },
      details: {
        reset: {
          title: 'Reset all points',
          question: 'Do you really want to reset all points? The points can be recalculated afterwards.',
        }
      },
      'details-modal': {
        title: 'Import details',
        error: {
          header: {
            message: 'Message',
            data: 'Data',
            attribute: 'Attribute',
            value: 'Value',
          },
        },
        data: {
          brand: 'Brand',
          rim: 'Rim',
          quantity: 'Quantity',
          points: 'Points',
          points_per_item: '{points} Points / Item',
          customer_number: 'Customer number',
        },
      },
      list: {
        header: {
          points: 'Points',
          historyStatus: 'State',
        },
        deleteImport: 'Delete import',
        deleteImportConfirm: 'Are you sure you want to delete this import?'
      },
      show: {
        header: {
          importer_points: 'Importer points',
          actual_points: 'Already imported points',
          expected_points: 'Points after import',
          imported_points: 'Imported points',
          delta_points: 'Difference',
        },
      },
      settings: {
        title: 'Importer settings',
        mode: 'Mode',
        modes: {
          merge: 'Merge',
          addition: 'Addition',
          direct: 'Direct point import without Adex',
        },
        skipRows: 'Skip rows',
        headerRow: 'Header row',
        firstRow: 'First row with data',
        allData: 'Import data without dealers',
        workSheet: 'Worksheet',
        columnSet: 'Column set: {type}',
        columns: 'Columns',
        columnConfiguration: 'Column configuration',
        columnData: {
          title: 'Column configuration / processing:',
          description: 'To ensure the importer works, we use any available or unused cell to overwrite it with data, for example, if the brand is not specified.',
        },
        parseColumnData: {
          title: 'Parse columns by pattern:',
          description: 'Example: <code>R(\\d{2})</code> searches for R00 - R99 in a string and returns the number. This allows us to read the rim size.',
        },
        replaceColumnData: {
          title: 'Replace column with:',
          description: 'In some cells, for example, <code>Bridgestone</code> needs to be converted to <code>bs</code> before import.',
        },
      }
    },
    'points-importer-types': {
      list: {
        table: {
          name: 'Name',
          description: 'Description',
        },
      },
    },
    menu: {
      'points-importer': 'Points importer',
      'points-importer-config-importers': 'Configuration',
      'points-importer-import': 'Import',
      'points-importer-import-history': 'Import History',
    },
    breadcrumb: {
      'points-importer': 'Points importer',
      'points-importer-config-importers': 'Configuration',
      'points-importer-config-edit-importer': 'Edit importers',
      'points-importer-import': 'Import',
      'points-importer-import-history': 'Import History',
      'points-importer-import-new': 'New import',
      'points-importer-import-show': 'Show import',
    },
  },
}
